export type ConfidenceStage = "personalised" | "verified" | "connected";

const STAGES: { key: ConfidenceStage; label: string; body: string }[] = [
  {
    key: "personalised",
    label: "Personalised",
    body: "Your property, roof and energy data are analysed and the system is modelled. Figures are modelled estimates.",
  },
  {
    key: "verified",
    label: "Verified",
    body: "A technical check confirms the roof, shading and electrics, usually from your portal. Figures update with that detail.",
  },
  {
    key: "connected",
    label: "Connected",
    body: "An installer fits and commissions the system. Performance is then tracked against this plan.",
  },
];

export default function ConfidenceStages({ current = "personalised" }: { current?: ConfidenceStage }) {
  const currentIndex = STAGES.findIndex((stage) => stage.key === current);

  return (
    <div className="flex flex-col gap-4 rounded-3xl border border-powlo-border bg-white p-6 sm:p-8">
      <div className="text-xs font-bold tracking-widest text-powlo-indigo">HOW SURE CAN YOU BE?</div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {STAGES.map((stage, index) => {
          const isCurrent = index === currentIndex;
          const isPast = index < currentIndex;
          return (
            <div
              key={stage.key}
              className={`flex flex-col gap-2 rounded-2xl border-2 p-5 ${
                isCurrent
                  ? "border-powlo-indigo bg-[#E9E7FF]"
                  : isPast
                    ? "border-powlo-border bg-powlo-cream"
                    : "border-powlo-border bg-white"
              }`}
            >
              <div className="flex items-center gap-2">
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                    isPast || isCurrent ? "bg-powlo-indigo text-white" : "border-2 border-powlo-border text-powlo-muted-light"
                  }`}
                >
                  {index + 1}
                </span>
                <span className={`font-powlo-display text-lg font-bold tracking-tight ${isCurrent ? "text-powlo-indigo" : "text-powlo-ink"}`}>
                  {stage.label}
                </span>
                {isCurrent && (
                  <span className="ml-auto rounded-full bg-powlo-indigo px-2.5 py-1 text-[10px] font-bold tracking-widest text-white">
                    YOU ARE HERE
                  </span>
                )}
              </div>
              <p className="m-0 text-sm leading-relaxed text-powlo-muted">{stage.body}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
